var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 2.04688L9.70312 0.851562C9.51562 0.664062 9.16406 0.5 8.90625 0.5H4.875C4.24219 0.5 3.75 1.01562 3.75 1.625V2.75H1.875C1.24219 2.75 0.75 3.26562 0.75 3.875V11.375C0.75 12.0078 1.24219 12.5 1.875 12.5H7.125C7.73438 12.5 8.25 12.0078 8.25 11.375V10.25H10.125C10.7344 10.25 11.25 9.75781 11.25 9.125V2.84375C11.25 2.58594 11.0859 2.23438 10.8984 2.04688ZM9 1.27344C9.04688 1.29688 9.11719 1.32031 9.16406 1.36719L10.3828 2.58594C10.4297 2.63281 10.4531 2.70312 10.4766 2.75H9V1.27344ZM7.5 11.375C7.5 11.5859 7.3125 11.75 7.125 11.75H1.875C1.66406 11.75 1.5 11.5859 1.5 11.375V3.875C1.5 3.6875 1.66406 3.5 1.875 3.5H3.75V9.125C3.75 9.75781 4.24219 10.25 4.875 10.25H7.5V11.375ZM10.5 9.125C10.5 9.33594 10.3125 9.5 10.125 9.5H4.875C4.66406 9.5 4.5 9.33594 4.5 9.125V1.625C4.5 1.4375 4.66406 1.25 4.875 1.25H8.25V2.9375C8.25 3.26562 8.48438 3.5 8.8125 3.5H10.5V9.125Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPrice);
export default __webpack_public_path__ + "static/media/copy_price.89bb3bcd.svg";
export { ForwardRef as ReactComponent };